import logo from "./logo.jpg";
import { useCookies } from "react-cookie";
export default function Header() {
  const [cookies, removeCookie] = useCookies(["user"]);
  const logout = () => {
    removeCookie("user");
  };
  return (
    <header className="App-header">
      <div>
        <img src={logo} className="App-logo" alt="logo" />
      </div>
      {cookies.user ? (
        <>
          <div style={{ marginRight: 8 }}>
            <h4 className="app-title">Administrator Panel</h4>
            <h3 style={{ margin: 0, fontWeight: 400, fontSize: "1.1em" }}>Users Device Console</h3>
            <div style={{ display: "flex", gap: 6, flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: 8, marginTop: 4 }}>
              <h5 style={{ margin: 0 }}>{cookies.user?.name}</h5>{" "}
              <h5
                onClick={() => {
                  logout();
                }}
                style={{ margin: 0, color: "red", cursor: "pointer" }}
              >
                Logout
              </h5>
            </div>
          </div>
        </>
      ) : (
        <h4 className="app-title">
          Audio Visual <br />
          Learning Resource
        </h4>
      )}
    </header>
  );
}
